import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './DashboardHeader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faList, faSignOutAlt, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

function DashboardHeader() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Function to check if a path is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Handle logout
  const handleLogout = () => {
    sessionStorage.removeItem('admin-login');
    window.location.href = '/';
  };

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="dashboard-header">
      <div className="dashboard-container">
        <div className="dashboard-logo">
          <Link to="/">
            <img src="/Logo/logob.png" alt="Logo" />
          </Link>
        </div>
        
        <h2 className="dashboard-title">Admin Dashboard</h2>
        
        <nav className="dashboard-nav">
          <Link
            to="/dashboard/create-blogs"
            className={`dashboard-nav-link ${isActive('/dashboard/create-blogs') ? 'active' : ''}`}
          >
            <FontAwesomeIcon icon={faPlus} className="nav-icon" />
            <span>Create Blogs</span>
          </Link>
          
          <Link
            to="/dashboard/view-blogs"
            className={`dashboard-nav-link ${isActive('/dashboard/view-blogs') ? 'active' : ''}`}
          >
            <FontAwesomeIcon icon={faList} className="nav-icon" />
            <span>View Blogs</span>
          </Link>
          
          <button
            className="dashboard-logout-btn"
            onClick={handleLogout}
            title="Logout"
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
          </button>
        </nav>
        
        {/* Mobile menu button */}
        <div className="dashboard-mobile-menu">
          <button 
            className="dashboard-mobile-menu-btn"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
          </button>
        </div>
      </div>
      
      {/* Mobile dropdown menu */}
      <div className={`dashboard-mobile-dropdown ${mobileMenuOpen ? 'open' : ''}`}>
        <Link
          to="/dashboard/create-blogs"
          className={`dashboard-mobile-link ${isActive('/dashboard/create-blogs') ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <FontAwesomeIcon icon={faPlus} className="mobile-nav-icon" />
          Create Blogs
        </Link>
        
        <Link
          to="/dashboard/view-blogs"
          className={`dashboard-mobile-link ${isActive('/dashboard/view-blogs') ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}
        >
          <FontAwesomeIcon icon={faList} className="mobile-nav-icon" />
          View Blogs
        </Link>
        
        <button
          className="dashboard-mobile-logout"
          onClick={handleLogout}
        >
          <FontAwesomeIcon icon={faSignOutAlt} className="mobile-nav-icon" />
          Logout
        </button>
      </div>
    </header>
  );
}

export default DashboardHeader;
